import { render, staticRenderFns } from "./PointsTab.vue?vue&type=template&id=9f4c98a2&scoped=true"
import script from "./PointsTab.vue?vue&type=script&lang=js"
export * from "./PointsTab.vue?vue&type=script&lang=js"
import style0 from "./PointsTab.vue?vue&type=style&index=0&id=9f4c98a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4c98a2",
  null
  
)

export default component.exports